if (!customElements.get("hero-slider")) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();

      this.mountSlider();

      window.addEventListener("shopify:block:select", (e) => {
        if (!e.target.closest("hero-slider")) return;

        const selectedSlideIndex = +e.target.dataset.index;
        this.slider.slideTo(selectedSlideIndex, 600);
      });

      this.addKeyboardNavigation();
    }

    mountSlider() {
      const autoplayOptions = {
        delay: this.dataset.autoplayInterval,
      };

      this.slider = new Swiper(this, {
        effect: "fade",
        rewind: true,
        slidesPerView: 1,
        speed: 600,
        followFinger: false,
        navigation: {
          nextEl: ".swiper-button--next",
          prevEl: ".swiper-button--prev",
        },
        autoplay: this.dataset.autoplay === "true" ? autoplayOptions : false,
        on: {
          init: this.handleSlideChange.bind(this),
          slideChange: this.handleSlideChange.bind(this),
        },
      });
    }

    handleSlideChange(swiper) {
      const slides = swiper.slides || [];
      const activeSlide = slides[swiper.activeIndex];

      if (!activeSlide) {
        return;
      }

      const blockId = this.getSlideBlockId(activeSlide);

      this.updateHeaderMenuColor(activeSlide);
      this.updateNavigationColors(activeSlide);
      this.syncProductsFeed(blockId);
      this.syncHeroButtons(blockId);
    }

    updateHeaderMenuColor(activeSlide) {
      const heroInner = activeSlide.querySelector(".hero__inner");

      if (!heroInner) {
        return;
      }

      const headerMenuColor = heroInner.dataset.headerMenuTextColor;

      if (!headerMenuColor) {
        return;
      }

      document.documentElement.style.setProperty(
        "--transparent-header-menu-text-color",
        headerMenuColor
      );
    }

    updateNavigationColors(activeSlide) {
      const heroContent = activeSlide.querySelector(".hero__content");
      const swiperButtons = this.querySelectorAll(".swiper-button");

      if (!heroContent || !swiperButtons.length) {
        return;
      }

      const classesToCopy = Array.from(heroContent.classList).filter(
        (className) => className.startsWith("text-colors-")
      );

      swiperButtons.forEach((button) => {
        Array.from(button.classList).forEach((className) => {
          if (className.startsWith("text-colors-")) {
            button.classList.remove(className);
          }
        });

        classesToCopy.forEach((className) => {
          button.classList.add(className);
        });
      });
    }

    syncProductsFeed(blockId) {
      if (!blockId) {
        return;
      }

      const wrapper = this.closest(".hero-banner-with-products-wrapper");

      if (!wrapper) {
        return;
      }

      const targetButton = wrapper.querySelector(
        `.products-feed__tab button[data-block-id="${blockId}"]`
      );

      if (targetButton) {
        targetButton.click();
      }
    }

    syncHeroButtons(blockId) {
      const wrapper = this.closest(".hero-banner-with-products-wrapper");

      if (!wrapper) {
        return;
      }

      const buttonGroups = wrapper.querySelectorAll(
        "[data-hero-buttons-group]"
      );

      if (!buttonGroups.length) {
        return;
      }

      buttonGroups.forEach((group) => {
        group.hidden = !blockId || group.dataset.blockId !== blockId;
      });
    }

    getSlideBlockId(slide) {
      if (!slide) {
        return null;
      }

      if (slide.dataset && slide.dataset.blockId) {
        return slide.dataset.blockId;
      }

      const nested = slide.querySelector("[data-block-id]");

      if (nested && nested.dataset) {
        return nested.dataset.blockId;
      }

      return null;
    }

    addKeyboardNavigation() {
      document.addEventListener("keydown", (event) => {
        if (this.isInViewport()) {
          if (event.key === "ArrowRight") {
            const nextButton = this.querySelector(".swiper-button--next");
            if (nextButton) {
              nextButton.click();
            }
          }
          if (event.key === "ArrowLeft") {
            const prevButton = this.querySelector(".swiper-button--prev");
            if (prevButton) {
              prevButton.click();
            }
          }
        }
      });
    }

    isInViewport() {
      const rect = this.getBoundingClientRect();
      return (
        rect.top < window.innerHeight && // top part in viewport
        rect.bottom > 0 && // bottom part in viewport
        rect.left < window.innerWidth && // left part in viewport
        rect.right > 0 // right part in viewport
      );
    }
  }

  customElements.define("hero-slider", HeroSlider);
}
